import { jwtDecode } from "jwt-decode";
import { DecodedToken } from "./DecodedToken";

export const getUserInfoFromToken = (
  token: string
): DecodedToken | null => {
  if (!token) return null;

  try {
    const decoded: DecodedToken = jwtDecode(token);
    return {
      email:
        decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"] ||
        decoded.email,
      role:
        decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] ||
        decoded.role,
      name:
        decoded.unique_name ||
        decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] ||
        decoded.name ||
        "",
    };
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};
